import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'host-status-right-calendar-cell',
  templateUrl: './status-right-calendar-cell.component.html',
  styleUrls: ['./status-right-calendar-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusRightCalendarCellComponent implements OnInit {
  @Input() hostStyle;
  @Input() hostClass;
  @Input() isInternational = false;
  @Input() showOversale = false;
  @Input() inventoryDiffInfo = null;
  @Input() house;
  @Input() houseCount = 0;
  // @Input() note = '';
  // @Input() bodyClass = {};
  // @Input() bodyStyle = {};
  constructor(public router: Router) {}

  ngOnInit() {}
}
